import queryString from 'query-string'
import { isEqual } from 'lodash'
import numeral from 'numeral'

export const capitalize = string => {
  return string
    .split('_')
    .map(([s, ...tring]) => [s.toUpperCase(), ...tring].join(''))
    .join('')
}

export const toSnakeCase = str =>
  str.replace(/\.?([A-Z]+)/g, (x, y) => '_' + y.toLowerCase()).replace(/^_/, '')

export const colorsList = [
  '#1997f4',
  '#e01b23',
  '#f3a536',
  '#49bd4f',
  '#cf2be0',
  '#6f29df',
  '#30d8a1',
  '#ebd930',
  '#85a610',
  '#8a572e',
  '#10a693',
  '#4b10a6',
  '#26a610',
  '#105aa6',
  '#a61050',
  '#3d5887',
  '#873d3d',
  '#3d8187',
  '#a410a6',
  '#873d3d'
]

export const getLabelColor = (position, colors = colorsList) => {
  if (position >= 0 && position < colors.length) {
    return colors[position]
  } else {
    return '#6d6d6d'
  }
}

export const getDifficultlyColor = (
  difficulty,
  reverse = false,
  divisibleFactor = 11.11,
  reduceFactor = 0
) => {
  let colors = [
    '#e31616',
    '#EC461D',
    '#f57523',
    '#F58E23',
    '#f5a623',
    '#B5B93B',
    '#9fbf43',
    '#71BF46',
    '#43bf48'
  ]

  if (reverse) {
    colors.reverse()
  }

  return colors[
    Math.min(8, Math.max(0, parseInt((difficulty - reduceFactor) / divisibleFactor, 10)))
  ]
}

export const generateLocationsList = locales => {
  if (!locales || !locales.length) {
    return []
  }

  return (
    locales
      .map(locale => {
        return {
          name: locale.locationName,
          value: locale.countryIsoCode,
          languages: locale.availableLanguages.map(lang => {
            return {
              name: lang.language_name,
              value: lang.language_code
            }
          })
        }
      })
      // Sort by name of each object
      .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
  )
}

export const generateRandomId = () =>
  Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substr(0, 5)

export const hasPropertyChain = (...args /* obj, level1, ... levelN*/) => {
  /* eslint-disable no-prototype-builtins */
  let obj = args[0]

  for (var i = 1; i < args.length; i++) {
    if (!obj || !obj.hasOwnProperty(args[i])) {
      return false
    }
    obj = obj[args[i]]
  }
  return true
  /* eslint-enable no-prototype-builtins */
}

export const get = (chain, defaultValue) => {
  /* eslint-disable no-prototype-builtins */
  let obj = chain[0]

  for (var i = 1; i < chain.length; i++) {
    if (!obj || !obj.hasOwnProperty(chain[i])) {
      return defaultValue
    }
    obj = obj[chain[i]]
  }

  return obj
  /* eslint-enable no-prototype-builtins */
}

export const getWithFormat = (chain, format = '0,0.[00]', defaultValue = '0') => {
  const value = Array.isArray(chain) ? get(chain, null) : chain
  if ([undefined, null, 0].indexOf(value) >= 0) {
    return defaultValue
  }
  if (isNaN(value)) {
    return value
  }
  return numeral(value).format(format)
}

export function processFixesData(chart, key) {
  const value = chart.slice(-1)[0][key] || 0
  const movement = value - (chart.slice(-2)[0][key] || 0)
  return {
    value,
    movement
  }
}

export const roundStat = num => parseFloat(parseFloat(Math.round(num * 100) / 100).toFixed(2))

export const formatCurrency = (value = 0, lang = 'en-US', currency = 'USD') => {
  try {
    return new Intl.NumberFormat(lang, {
      style: 'currency',
      currency
    }).format(value)
  } catch (e) {
    return numeral(value).format('0,0.00')
  }
}

export const processSortParam = a => {
  /* eslint-disable no-prototype-builtins */
  a = typeof a === 'string' ? a.toLowerCase() : a

  if (
    a !== null &&
    typeof a === 'object' &&
    typeof a.props === 'object' &&
    a.props.hasOwnProperty('sortingvalue')
  ) {
    a = !isNaN(parseFloat(a.props.sortingvalue))
      ? parseFloat(a.props.sortingvalue)
      : typeof a.props.sortingvalue === 'string'
      ? a.props.sortingvalue.toLowerCase()
      : 0
  }

  a = a === null || a === undefined ? '-' : a

  return a
  /* eslint-enable no-prototype-builtins */
}

// export const defaultSortMethod = (a, b, desc) => {
//   // force any string values to lowercase
//   a = processSortParam(a)
//   b = processSortParam(b)

//   // Deal with the dashes. These
//   // should always be at the end
//   // of the table
//   if (a === '-') {
//     return desc ? -1 : 1
//   }

//   if (b === '-') {
//     return desc ? 1 : -1
//   }

//   if (a > b) {
//     return 1
//   }

//   if (a <= b) {
//     return -1
//   }

//   return 0
// }

export function addOrRemove(array, item) {
  const idx = array.indexOf(item)

  if (idx === -1) {
    array.push(item)
  } else {
    array.splice(idx, 1)
  }
}

export function getArrayFromStorage(data) {
  try {
    return data ? JSON.parse(data) : []
  } catch (exc) {
    return []
  }
}

export const isDefaultFilter = currentFilter => {
  return isEqual(currentFilter, {
    device: ''
  })
}

const getQuery = () => {
  if(!window?.location?.search) return {}
  return queryString.parse(window.location.search)
}

export const query = getQuery()

export const deriveClassnameAndValue = (previous, current, change) => {
  // let returnValue = change
  // let positiveValue = true
  // if (!isNaN(change)) {
  //   if (Math.sign(change) > 0) {
  //     returnValue = `+${change}`
  //     positiveValue = false
  //   } else {
  //     returnValue = `-${Math.abs(change)}`
  //     positiveValue = true
  //   }
  // }
  if (previous === 0 && current !== 0) {
    return { value: 'New', color: 'brand.success' }
  }
  if (current === 0 && previous !== 0) {
    return { value: 'Lost', color: 'brand.success' }
  }
  const value = previous - current
  return {
    value,
    color: value > 0 ? 'brand.success' : 'brand.error'
  }
}

export const colourHelper = colour => (colour.indexOf('#') === -1 ? `#${colour}` : colour)

export const checkJWTFormat = jwt => {
  // NOTE: Not bullet proof!
  return /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/.test(jwt)
}

export const removeHTTPProtocol = (domain = '') => {
  return domain
    .replace(/^\s+/, '')
    .replace(/^(\w+:)?\/?\//, '')
    .replace(/\s+$/, '')
}

export function noop() {}

export function isEmptyArray(arr) {
  return (
    Array.isArray(arr) &&
    (arr.length === 0 ||
      arr.every(function(i) {
        return !i
      }))
  )
}

export function isArraysEqual(a, b) {
  if (a === b) return true
  if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
    return false
  }
  if (a.length !== b.length) return false

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false
  }
  return true
}

function isObj(variable) {
  return !!variable && variable.constructor === Object
}

function processParam(key, params, pref) {
  const elem = pref ? `${pref}[${key}]` : key
  switch (true) {
    case isObj(params[key]):
      return fromObject(params[key], elem)
    case Array.isArray(params[key]):
      return params[key].map((item, ind) => fromObject(item, `${elem}[${ind + 1}]`)).join('')
    default:
      return `${elem}=${encodeURIComponent(params[key])}&`
  }
}

export function fromObject(params, pref) {
  if (pref === void 0) {
    pref = ''
  }
  if (typeof params !== 'object') {
    return pref + '=' + encodeURIComponent(params) + '&'
  }
  const keysArray = Object.keys(params)
  return keysArray.map((key, index) => processParam(key, params, pref)).join('')
}

export const MatchTypes = {
  exact: {
    text: 'URL',
    caption: 'Exact URL'
  },
  path: {
    text: 'Prefix',
    caption: 'domain.com/path/*'
  },
  nosubdomains: {
    text: 'domain/*',
    caption: 'Domain without subdomains'
  },
  any: {
    text: '*.domain/*',
    caption: 'Domain with all its subdomains'
  }
}

export function positionDisplay(value) {
  return value >= 101 ? '101+' : value
}
